import api from "../../utils/Api";
import {
  SAVE_MEDICAL_NOTES_REQUEST,
  SAVE_MEDICAL_NOTES_SUCCESS,
  SAVE_MEDICAL_NOTES_ERROR,
} from "./SaveMedicalNotesTypes";

export const saveMedicalNotesRequest = () => {
  return {
    type: SAVE_MEDICAL_NOTES_REQUEST,
  };
};

export const saveMedicalNotesSuccess = (savedMedicalNotesData) => {
  return {
    type: SAVE_MEDICAL_NOTES_SUCCESS,
    payload: savedMedicalNotesData,
  };
};

export const saveMedicalNotesFailure = (error) => {
  return {
    type: SAVE_MEDICAL_NOTES_ERROR,
    payload: error,
  };
};

export const saveMedicalNotes = (payload) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
  return async (dispatch) => {
    dispatch(saveMedicalNotesRequest());
    try {
        const response = await api.post("practise/medicalnotes/save", payload, {
            headers: headers,
          });
      const savedMedicalNotesData = response.data;
      dispatch(saveMedicalNotesSuccess(savedMedicalNotesData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(saveMedicalNotesFailure(errorMsg));
    }
  };
};
